__turbopack_context__.v({
  "container": "PaymentMethodsLogo-module-scss-module__BNlN4G__container",
  "logo": "PaymentMethodsLogo-module-scss-module__BNlN4G__logo",
  "spin": "PaymentMethodsLogo-module-scss-module__BNlN4G__spin",
  "spinner": "PaymentMethodsLogo-module-scss-module__BNlN4G__spinner",
});
